var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"enter-active-class":"animated faster fadeIn","leave-active-class":"animated faster fadeOut"}},[(_vm.renderLoading)?_c('div',{staticClass:"center-loading"},[_c('div',{staticClass:"iconfont icon-loading-loop loading-loop"})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }